import axios from 'axios';

const grappleAi = (message, paraPrompt, email) => {
  const config = {
    headers: {
      Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
  };

  const body = {
    message: message,
    system: paraPrompt,
    email: email,
  };

  return axios.post(`${process.env.NEXT_PUBLIC_GRAPPLE_BACKEND_URL}grapple-ai`, body, config);
};

export default grappleAi;
